//Jumio mock data for testing in localhost
export const JUMIOPASSMOCK = {
  idCountry: "IND",
  idDob: "1976-08-02",
  idLastName: "AJI",
  idNumber: "AFCPR6952F",
  idType: "ID_CARD",
  nationality: "IND",
  personalNumber: "N/A",
  presetCountry: "IND",
  signatureAvailable: "false",
  transactionDate: "2026-07-02T05:24:20.866Z",
  verificationStatus: "APPROVED_REVERIFIED"
};
